import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskSharedPage = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskSharedPage;
